module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "editquizzes"
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('b-list-group', [(_vm.quizzes && _vm.quizzes.length == 0) ? _c('b-list-group-item', {
    staticClass: "py-3 text-info"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.quizzes), function(quiz, key) {
    return _c('a', {
      key: key,
      staticClass: "list-group-item list-group-item-action",
      class: {
        'active': _vm.activeQuizKey == key
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openQuiz(key)
        }
      }
    }, [(quiz.public) ? _c('i', {
      staticClass: "fa fa-globe fa-fw"
    }) : _vm._e(), _vm._v(" " + _vm._s(quiz.name) + "\n\t\t\t\t")])
  }), _vm._v(" "), _c('b-list-group-item', [_c('p', {
    staticClass: "w-100"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Titel..."
    },
    model: {
      value: (_vm.newQuizName),
      callback: function($$v) {
        _vm.newQuizName = $$v
      },
      expression: "newQuizName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center w-100"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.newQuizName === '',
      "variant": 'warning'
    },
    on: {
      "click": _vm.addQuiz
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Quiz hinzufügen")])], 1)])], 2)], 1), _vm._v(" "), (_vm.activeQuizKey !== null) ? _c('div', {
    staticClass: "col-12 col-md-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 py-2 text-right"
  }, [_c('b-form-checkbox', {
    attrs: {
      "true-value": true,
      "false-value": false
    },
    model: {
      value: (_vm.activeQuiz.public),
      callback: function($$v) {
        _vm.activeQuiz.public = $$v
      },
      expression: "activeQuiz.public"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.activeQuiz.public ? 'Öffentlich' : 'Nicht öffentlich') + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'success',
      "disabled": !_vm.saveEligible
    },
    on: {
      "click": _vm.updateQuiz
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'link',
      "size": 'sm',
      "title": "Löschen mit Doppelklick."
    },
    nativeOn: {
      "dblclick": function($event) {
        _vm.removeQuiz(_vm.activeQuizKey)
      }
    }
  }, [_vm._v("Löschen")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'link',
      "size": 'sm',
      "title": "Quiz schließen"
    },
    on: {
      "click": _vm.closeQuiz
    }
  }, [_vm._v("schließen")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'secondary',
      "size": 'sm',
      "title": "Quiz downloaden"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 py-2"
  }, [_c('b-input-group', {
    attrs: {
      "left": "Überschrift",
      "size": 'lg'
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.activeQuiz.name),
      callback: function($$v) {
        _vm.activeQuiz.name = $$v
      },
      expression: "activeQuiz.name"
    }
  })], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "textarea": true,
      "placeholder": "Beschreibung..."
    },
    model: {
      value: (_vm.activeQuiz.description),
      callback: function($$v) {
        _vm.activeQuiz.description = $$v
      },
      expression: "activeQuiz.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "list-group",
    attrs: {
      "id": "items"
    }
  }, _vm._l((_vm.activeQuiz.questions), function(question, key) {
    return _c('div', {
      key: question,
      staticClass: "list-group-item mb-2 border-0 px-0"
    }, [_c('div', {
      staticClass: "col-12 px-0"
    }, [_c('h6', [_c('i', {
      staticClass: "fa fa-arrows-alt fa-fw handle"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(key + 1) + ". Frage\n\t\t\t\t\t\t\t\t\t\t\t"), _c('b-button', {
      staticClass: "text-muted pull-right",
      attrs: {
        "variant": 'link',
        "size": 'sm'
      },
      nativeOn: {
        "dblclick": function($event) {
          _vm.removeQuestion(key)
        }
      }
    }, [_vm._v("entfernen")])], 1)]), _vm._v(" "), _c('question-' + question.type + '-edit', {
      tag: "div",
      staticClass: "col-12 px-0",
      attrs: {
        "question": question,
        "questionKey": key
      },
      on: {
        "remove": _vm.removeQuestion
      }
    })])
  })), _vm._v(" "), _c('div', _vm._l((_vm.questionTypes), function(type, key) {
    return _c('b-button', {
      key: key,
      on: {
        "click": function($event) {
          _vm.addQuestion(type.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-fw"
    }), _vm._v(" " + _vm._s(type.buttonText))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.activeQuiz.variables && _vm.activeQuiz.variables.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 ml-1"
  }, [_vm._v("von")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 ml-1"
  }, [_vm._v("bis")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeQuiz.variables), function(variable, variableKey) {
    return _c('div', {
      key: variableKey,
      staticClass: "row mb-2"
    }, [_c('b-form-input', {
      staticClass: "col-3",
      attrs: {
        "type": 'text'
      },
      model: {
        value: (variable.name),
        callback: function($$v) {
          variable.name = $$v
        },
        expression: "variable.name"
      }
    }), _vm._v(" "), _c('b-form-input', {
      staticClass: "col-3 ml-1",
      attrs: {
        "type": 'number'
      },
      model: {
        value: (variable.from),
        callback: function($$v) {
          variable.from = $$v
        },
        expression: "variable.from"
      }
    }), _vm._v(" "), _c('b-form-input', {
      staticClass: "col-3 ml-1",
      attrs: {
        "type": 'number'
      },
      model: {
        value: (variable.to),
        callback: function($$v) {
          variable.to = $$v
        },
        expression: "variable.to"
      }
    }), _vm._v(" "), _c('b-button', {
      staticClass: "col-2",
      attrs: {
        "variant": 'link'
      },
      on: {
        "click": function($event) {
          _vm.removeVariable(variableKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times fa-fw"
    })])], 1)
  }), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    on: {
      "click": _vm.addVariable
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v(" Variable")])], 2)])])])]) : _c('div', {
    staticClass: "col-12 col-md-9"
  }, [_c('h3', [_vm._v("So geht's")]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("Videos")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tUm Videos einzubinden schreibt man:\n\t\t\t\t\t"), _c('code', [_vm._v("[video:http://www.youtube.com/embed/"), _c('strong', [_vm._v("DLzxrzFCyOs")]), _vm._v("?rel=0]")])])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v(":Variablen:")]), _vm._v(" "), _c('dd', [_vm._v("Den Namen der Variablen einfach in \":\" setzen."), _c('br'), _vm._v(" "), _c('code', [_vm._v(":a: + :b:")]), _vm._v(" wird zu "), _c('code', [_vm._v("3 + 4")]), _vm._v(", wenn a = 3 und b = 4.")])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("$Latex$")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tLatex ist via "), _c('a', {
    attrs: {
      "href": "https://www.mathjax.org/",
      "target": "_blank"
    }
  }, [_vm._v("MathJax")]), _vm._v(" möglich. Also einfach in Dollarzeichen setzen."), _c('br'), _vm._v(" "), _c('code', [_vm._v("$ :a: \\over :b:$")]), _vm._v(" ergibt einen schönen Bruch."), _c('br'), _vm._v("\n\t\t\t\t\tMit zwei Dollarzeichen wird die Mathematik in einer Zeile mittig angezeigt.\n\t\t\t\t")])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("§Berechnungen§")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tMöchte man etwas berechnen lassen, stellt man den mathematischen Ausdruck in Paragrafen."), _c('br'), _vm._v(" "), _c('code', [_vm._v("§3+4§")]), _vm._v(" ergibt "), _c('code', [_vm._v("7")]), _c('br'), _vm._v("\n\t\t\t\t\tDies ist auch in Verbindung mit Variablen möglich."), _c('br'), _vm._v(" "), _c('code', [_vm._v("§ :a:/:b:§")]), _vm._v(" ergibt "), _c('code', [_vm._v("0,75")]), _vm._v(".\n\t\t\t\t")])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("Komplexere Berechnungen")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tDie gängisten Funktionen sind via "), _c('a', {
    attrs: {
      "href": "http://mathjs.org/",
      "target": "_blank"
    }
  }, [_vm._v("math.js")]), _vm._v(" in Berechnungen verfügbar."), _c('br'), _vm._v(" "), _c('code', [_vm._v("§ round( sin( 40 deg), 2)§")]), _vm._v(" ergibt "), _c('code', [_vm._v("0,64")]), _vm._v(".\n\t\t\t\t")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e274858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/router/EditQuizzes.vue
// module id = 709
// module chunks = 1